// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"a8-z"};